import angular from 'angular';
import noFinancials from './noFinancials';

export default angular
  .module('components.noFinancials', [])
  .component('noFinancials', noFinancials).name;
